/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

export class Duration extends BaseField {

    protected opts: DurationOptions;

    private hourInput: JQuery;
    private minuteInput: JQuery;

    constructor (element: string | JQuery, opts: DurationOptions = {}) {
        super(element, opts);

        this.hourInput = this.element.find('#' + this.element.prop('id') + '_hour');
        this.minuteInput = this.element.find('#' + this.element.prop('id') + '_minute');

        this.element.on('change', () => {
            this.onChange();
        });

        /*this.element.on('keyup', () => {
            this.recalculate();
        });*/
    }

    public setEnabled(enabled: boolean) {
        super.setEnabled(enabled);

        if (enabled) {
            this.hourInput
                .prop('disabled', false)
                .removeClass('disabled');
            this.minuteInput
                .prop('disabled', false)
                .removeClass('disabled');
        } else {
            this.hourInput
                .prop('disabled', true)
                .addClass('disabled');
            this.minuteInput
                .prop('disabled', true)
                .addClass('disabled');
        }
    }

    public setValue(newValue: any) {

        let changed = false;

        // If newValue is exactly the same, ignore.
        if (this.value === newValue) {
            return;
        }

        if (newValue === undefined) {
            this.value = undefined;
            changed = true;
        }

        if (typeof newValue === 'number' && !isNaN(newValue)) {
            this.value = newValue;
            changed = true;
        }

        if (changed) {
            this.setDirty(true);
            this.formatDisplay();
        }
    }

    public onChange() {
        let hourVal = this.hourInput.val().trim();
        let minuteVal = this.minuteInput.val().trim();

        // Blank, set to undefined.
        if (hourVal === '' && minuteVal === '') {
            this.setValue(undefined);
            return;
        }

        if (hourVal === '') {
            hourVal = '0';
        }

        if (minuteVal === '') {
            minuteVal = '0';
        }

        if (!hourVal.match(/^\d+$/) || !minuteVal.match(/^\d+$/)) {
            this.value = undefined;
            return;
        }

        let hour = parseInt(hourVal, 10);
        let minute = parseInt(minuteVal, 10);

        if (isNaN(hour) || isNaN(minute) || hour < 0 || minute < 0 || minute > 59) {
            this.setValue(undefined);
            this.value = undefined;
            return;
        }

        this.setValue(hour * 3600000 + minute * 60000);
    }

    private formatDisplay() {
        if (this.value === undefined) {
            this.hourInput.val('');
            this.minuteInput.val('');
            return;
        }

        this.hourInput.val(Math.floor(this.value / 3600000));
        this.minuteInput.val(Math.floor((this.value % 3600000) / 60000));
    }
}

interface DurationOptions extends FieldOptions {
}

}
